import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function IdsCheckBoxBlank(props: SvgIconProps) {
  return(
    <SvgIcon {...props}>
      <path id="footprint" d="M0,0H24V24H0V0Z" fill="none"/>
      <g id="unchecked">
        <rect id="base" x="2.28" y="2.5" width="19.44" height="19" rx="1.5" ry="1.5" fill="#fff"/>
        <rect id="border" x="2.28" y="2.5" width="19.44" height="19" rx="1.5" ry="1.5" fill="none" stroke="#000"/>
      </g>
    </SvgIcon>
  );
}